import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import BaseService from "@/views/base/base.service";
import {
  ClientInfo,
  ClientDDL,
  ChangePassword,
  RegisterUserDto,
  DropdownItem
} from "@/views/base/base.types";

@Module({ namespaced: true })
class Base extends VuexModule {
  clientInfo: ClientInfo[] = [];
  clientDDL: ClientDDL[] = [];
  aspNetRolesDDL: DropdownItem<string>[] = [];
  selectedClientDDL = new ClientDDL();
  errorMessage: string | null = null;
  clientReady = false;

  private _initialState!: Record<string, any>;

  constructor(module: any) {
    super(module);
    this._initialState = { ...this };
  }

  @Action({ rawError: true })
  async fetchClientInfo(loginId: number) {
    this.context.commit("updateField", {
      path: "clientDDL",
      value: []
    });
    const clientInfo = await BaseService.getClients(loginId);
    this.context.commit("updateField", {
      path: "clientInfo",
      value: clientInfo
    });
    const clientDDL = clientInfo.map((clientInfo: any) => {
      return {
        text: clientInfo.clientName,
        value: clientInfo.clientId
      }
    });
    this.context.commit("updateField", {
      path: "clientDDL",
      value: clientDDL
    });
    if (clientDDL.length > 0) {
      this.context.commit("updateField", {
        path: "selectedClientDDL",
        value: clientDDL[0]
      });
    }
    this.context.commit("updateField", {
      path: "clientReady",
      value: true
    });
  }

  @Action({ rawError: true })
  async fetchAspNetRoles() {
    const aspNetRolesDDL = await BaseService.getAspNetRoles();
    this.context.commit("updateField", {
      path: "aspNetRolesDDL",
      value: aspNetRolesDDL
    });
  }

  @Action({ rawError: true })
  async changePassword(changePassword: ChangePassword) {
    try {
      this.context.commit("updateField", {
        path: "errorMessage",
        value: null
      });
      await BaseService.changePassword(changePassword);
    } catch (e: any) {
      const errorMessage = e.response.data.message;
      this.context.commit("updateField", {
        path: "errorMessage",
        value: errorMessage
      });
    }
  }

  @Action({ rawError: true })
  async registerUser(registerUserDto: RegisterUserDto) {
    try {
      this.context.commit("updateField", {
        path: "errorMessage",
        value: null
      });
      await BaseService.registerUser(registerUserDto);
    } catch (e: any) {
      const errorMessage = e.response.data.message;
      this.context.commit("updateField", {
        path: "errorMessage",
        value: errorMessage
      });
    }
  }

  @Action({ rawError: true })
  resetState() {
    for (const key of Object.keys(this._initialState)) {
      this.context.commit("updateField", {
        path: key,
        value: this._initialState[key]
      });
    }
  }
}

Base.getters = { getField };
Base.mutations = { updateField };

export default Base;